import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { SandboxCardComponent } from './sandbox-card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


@NgModule({
  declarations: [
    SandboxCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
    MatDividerModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    SandboxCardComponent
  ]
})
export class SandboxCardModule { }
